import { Injectable } from '@angular/core';
import { ApiError, filterApiErrorList, removeApiError } from '@shared/models/apiError';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  apiErrorList= new BehaviorSubject<ApiError[]>([]);

  errorList:ApiError[]=[];

  constructor(){
    this.apiErrorList.subscribe(
      r=>{
        this.errorList=r;
      }
    )
  }

  setApiError(error:any){
    this.apiErrorList.next(filterApiErrorList(this.errorList,error))
  }

  removeErrorOnTabChange(tab:string){
    this.apiErrorList.next(removeApiError(this.errorList,tab));
  }

}
